import React from "react"
import styles from "./CompanyEmployeeItem.module.scss"
import classNames from "classnames"
import PropTypes from "prop-types"
import ThreeDotsMenu from "../../ThreeDotsMenu/ThreeDotsMenu"
import CustomTooltip from "../../CompanyUserInfo/CustomTooltip"

const CompanyEmployeeItem = ({ employeeInfo, status, onDelete, withMenu, employeeRole, adminLabel }) => {
  const menu = [
    {
      name: "Delete",
      click: () => {
        onDelete(employeeInfo)
      },
    },
  ]

  const displayName = employeeInfo.full_name
  const adminLabelText = adminLabel ? ` - ${adminLabel}` : ""

  return (
    <div className={styles.employeeWrapper}>
      {displayName?.length > 27 ? (
        <CustomTooltip name={displayName}>
          <p className={styles.name}>
            {displayName}
            {adminLabel && <span className={styles.adminLabel}>{adminLabelText}</span>}
          </p>
        </CustomTooltip>
      ) : (
        <p className={styles.name}>
          {displayName}
          {adminLabel && <span className={styles.adminLabel}>{adminLabelText}</span>}
        </p>
      )}
      <p className={styles.email}>{employeeInfo.email}</p>
      <div className={styles.separator}></div>
      <div className={styles.statusWrapper}>
        <p
          className={classNames(styles.status, {
            [styles.hidden]: !status,
          })}
        >
          {status ? status.toLowerCase() : ""}
        </p>
        {withMenu && (
          <div className={styles.threeDots}>
            <ThreeDotsMenu actions={menu} />
          </div>
        )}
      </div>
    </div>
  )
}

CompanyEmployeeItem.propTypes = {
  departmentInfo: PropTypes.shape({
    name: PropTypes.string,
    employees_count: PropTypes.number,
    open_opportunities: PropTypes.number,
  }),
}

export default CompanyEmployeeItem
